export const trackUserSignIn = (id: string, email: string, isDev: boolean) => {
  // @ts-ignore
  heap.identify(id);
  // @ts-ignore
  heap.addUserProperties({ email, dev: isDev });
}

export const trackEmployeeSignIn = (id: string, email: string) => {
  // @ts-ignore
  heap.identify(id);
  // @ts-ignore
  heap.addUserProperties({ email, kaEmployee: true });
}

export const trackBusinessSelected = (id?: string, name?: string) => {
  // @ts-ignore
  heap.addUserProperties({ businessId: id, businessName: name });
}

export const clearTracking = () => {
  // @ts-ignore
  heap.resetIdentity();
}
